(function () {
  var STORAGE_KEY = 'rb_age_verified';
  var DENY_URL = 'https://www.google.com/';
  var gate = document.getElementById('rb-age-gate');
  if (!gate) return;

  /* Attestation storage and its 90-day TTL live in rb-age-verify.js so the head-loaded
     rb-cookie-hold.js and this deferred script cannot disagree about who is verified.
     The fallbacks below only matter if that file fails to load. */
  function verified() {
    if (window.rbAgeVerify) return window.rbAgeVerify.isVerified();
    try {
      return !!window.localStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return false;
    }
  }

  function setVerified() {
    if (window.rbAgeVerify) {
      window.rbAgeVerify.setVerified();
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (err) {
      /* ignore */
    }
  }

  function syncScale() {
    if (typeof window.rbSyncDesktopScale === 'function') window.rbSyncDesktopScale();
  }

  function openGate() {
    gate.classList.add('is-open');
    document.documentElement.classList.add('rb-age-gate-open');
    try {
      if (typeof gate.showModal === 'function') {
        if (!gate.open) gate.showModal();
      }
    } catch (err) {}
    syncScale();
    var accept = gate.querySelector('[data-rb-age-accept]');
    if (accept) window.setTimeout(function () { accept.focus(); }, 50);
  }

  function closeGate() {
    gate.classList.remove('is-open');
    document.documentElement.classList.remove('rb-age-gate-open');
    try {
      if (typeof gate.close === 'function' && gate.open) gate.close();
    } catch (err) {}
    syncScale();
    /* rb-cookie-hold-v1 listens for this to put the Consentmo notice back. Dispatched from
       closeGate rather than the accept handler so every exit from the gate releases it. */
    try {
      document.dispatchEvent(new CustomEvent('rb:age-gate-closed'));
    } catch (err) {
      /* CustomEvent constructor unavailable — the hold script's DOMContentLoaded
         failsafe still prevents the notice from being suppressed permanently. */
    }
  }

  /*
   * Consentmo is only CSS-held while the age gate is open.
   * After closeGate(), do NOT call Consentmo.openDialog() — that re-opens
   * the notice after the visitor already accepted (seen as a double banner).
   * Consentmo shows itself when needed once the hold class is removed.
   */

  /*
   * rb-crawler-v1 — search and AI crawlers read the page, they never buy, so the
   * 21+ attestation has nobody to attest. Leaving the modal up costs indexing:
   * showModal() marks the rest of the document inert and the backdrop covers it.
   */
  if (window.rbIsCrawler || verified()) {
    closeGate();
    return;
  }

  openGate();

  var acceptBtn = gate.querySelector('[data-rb-age-accept]');
  var denyBtn = gate.querySelector('[data-rb-age-deny]');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      setVerified();
      closeGate();
    });
  }

  if (denyBtn) {
    denyBtn.addEventListener('click', function () {
      window.location.href = DENY_URL;
    });
  }

  /* Stay until they choose — Escape must not dismiss */
  gate.addEventListener('cancel', function (event) {
    event.preventDefault();
  });

  /* Trap focus inside the dialog while open */
  gate.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = gate.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
